export default function (axios) {
  return {
    // 退出登录接口
    // logout() {
    //   return axios.get("/invalidToken");
    // },

    // // 获取验证码
    // getCode(userLoginCode, type) {
    //   return axios.get("/anon/verifyCode", {
    //     params: { userLoginCode, verifyType: type ? type : 2 },
    //   });
    // },

    // // 获取用户信息
    // getUserInfo() {
    //   return axios.get("/userCtl/selectUserInfoByToken");
    // },

    // // 获取验证码
    // getCode(userLoginCode, type) {
    //   return axios.get("/anon/verifyCode", {
    //     params: { userLoginCode, verifyType: type ? type : 2 },
    //   });
    // },
    
    

    // // 清空员工权限
    // emptyStaffAuth(params) {
    //   return axios.post("/cPowerSetCtl/emptyPower", null, {
    //     params,
    //   });
    // },

    // /查询单个项目的已选成员和管理员
    getCustomerMember(compId, customerId) {
      return axios.get("/customer/selectCustomerMember", {
        params: { compId, customerId },
      });
    },
    // 添加客户的成员
    addCustomerMember(params) {
      return axios.post("/customer/addCustomerMember", params);
    },
    //删除客户成员
    deleteCustomerMember(params) {
      return axios.post("/customer/deleteCustomerMember", params);
    },
    //查询单个项目的已选成员和管理员
    getSelectSupplierMember(compId, customerId) {
      return axios.get("/outsource/selectSupplierMember", {
        params: { compId, customerId },
      });
    },
    // 添加供应商的成员
    addSupplierMember(params) {
      return axios.post("/outsource/addSupplierMember", params);
    },
    //删除客户成员
    deleteSupplierMember(params) {
      return axios.post("/outsource/deleteSupplierMember", params);
    },

    // // 获取员工列表
    // getStaff(params, controller) {
    //   let url = "/compStaffMember/selectCompStaffMemberPage"
    //   let signal =
    //     controller && controller.signal ? { signal: controller.signal } : {};
    //   console.log(signal)
    //   params.signal = signal
    //   return axios.post(
    //     url,
    //     {},
    //     { params }
    //   );
    // },

    
    
  };
}
